// src/components/PrivateRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// PrivateRoute component to protect routes
const PrivateRoute = ({ element, ...rest }) => {
  const { authToken } = useAuth();  // Get the authToken from context

  return authToken ? element : <Navigate to="/" />;  // Redirect to login page if no authToken
};

export default PrivateRoute;
